export var setCookie = function setCookie(name, value) {
  var domain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'cian.ru';
  var expires = new Date('2099-01-01').toUTCString();
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), "; domain=").concat(domain, "; path=/; expires=").concat(expires);
};
export var getCookie = function getCookie(name) {
  return document.cookie.split('; ').reduce(function (r, v) {
    var parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');
};
export var deleteCookie = function deleteCookie(name) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cian.ru';
  document.cookie = "".concat(name, "=; domain=").concat(domain, "; path=/; expires=0");
};